import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import common from "./shared/common"

import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import i18n from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";
import VueSweetalert2 from "vue-sweetalert2"
import VueCookies from 'vue-cookies';
import lodash from "lodash";
import VueLodash from "vue-lodash";
import VueRadioToggleButtons from 'vue-radio-toggle-buttons';

import "sweetalert2/dist/sweetalert2.min.css"
import "vue-multiselect/dist/vue-multiselect.min.css"
import 'vue2-datepicker/index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';
import "./style.css";
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from "vue2-google-maps"
import trimOnBlurmixins from './shared/trimOnBlurmixins'

/* import specific icons */
import { faAddressCard, faCaretDown, faCircleChevronLeft, faEdit, faEllipsis, faFileCirclePlus, faFilePen, faFileLines, faLocationDot, faMinus, faPaperPlane, faPersonWalkingArrowRight, faPhoneVolume, faPlus, faPrint, faRightFromBracket, faRightToBracket, faRotateLeft, faSearch, faTrashCan, faUserPen, faUserPlus, faEye, faCaretRight, faCirclePlus, faFlag, faUnlockAlt, faExternalLink, faCircleQuestion, faCircleXmark, faUsers, faClockRotateLeft, faListUl, faStar, faHome, faChevronUp, faChevronDown, faLocationCrosshairs, faLayerGroup, faGear } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faFilePen, faPersonWalkingArrowRight, faAddressCard, faEllipsis, faFileLines, faFileCirclePlus, faSearch, faRotateLeft, faCaretDown, faRightFromBracket, faUserPen, faCircleChevronLeft, faPhoneVolume, faPaperPlane, faEdit, faLocationDot, faPlus, faMinus, faTrashCan, faPrint, faRightToBracket, faUserPlus, faEye, faCaretRight, faCirclePlus, faFlag, faUnlockAlt, faExternalLink, faCircleQuestion, faCircleXmark, faUsers, faClockRotateLeft, faListUl, faStar, faHome, faChevronUp, faChevronDown, faLocationCrosshairs, faLayerGroup, faGear)
/* add font awesome icon component */
import Popover from 'vue-js-popover'
import './shared/dom-node-inserted-polyfill.js';


Vue.use(Popover)
Vue.use(VueRadioToggleButtons);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(FlagIcon);
Vue.use(VueSweetalert2);
Vue.use(VueCookies);
Vue.mixin(common)
Vue.use(VueLodash, lodash);
Vue.config.productionTip = false
/* trimOnBlurmixins for trim all inputs trim after typing complete */
Vue.mixin(trimOnBlurmixins);

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyAVU3kaMH_8F_CsjCZrJV4afvvlEX16Eug",
		libraries: "places" // necessary for places input
	}
});

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
